<template>
  <v-container class="pt-0">
    <v-row align="center">
      <v-spacer class="hidden-sm-and-down"/>
      <v-col class="pa-0" cols="12" md="auto">
        <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
          &copy; {{ new Date().getFullYear() }}, made by
          <v-icon class="mr-1">mdi-coffee</v-icon>
          <span class="text-decoration-none"><b>H2 Sistemas</b></span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Links",
  data: () => ({}),
};
</script>

<style lang="sass" scoped>
a
  color: inherit !important
</style>
